export const LIST_PROFILE_SETUP_REQUEST = 'LIST_PROFILE_SETUP_REQUEST'
export const LIST_PROFILE_SETUP_SUCCESS = 'LIST_PROFILE_SETUP_SUCCESS'
export const LIST_PROFILE_SETUP_FAIL = 'LIST_PROFILE_SETUP_FAIL'

export const CREATE_PROFILE_SETUP_REQUEST = 'CREATE_PROFILE_SETUP_REQUEST'
export const CREATE_PROFILE_SETUP_SUCCESS = 'CREATE_PROFILE_SETUP_SUCCESS'
export const CREATE_PROFILE_SETUP_FAIL = 'CREATE_PROFILE_SETUP_FAIL'

export const DETAIL_PROFILE_SETUP_REQUEST = 'DETAIL_PROFILE_SETUP_REQUEST'
export const DETAIL_PROFILE_SETUP_SUCCESS = 'DETAIL_PROFILE_SETUP_SUCCESS'
export const DETAIL_PROFILE_SETUP_FAIL = 'DETAIL_PROFILE_SETUP_FAIL'

export const UPDATE_PROFILE_SETUP_REQUEST = 'UPDATE_PROFILE_SETUP_REQUEST'
export const UPDATE_PROFILE_SETUP_SUCCESS = 'UPDATE_PROFILE_SETUP_SUCCESS'
export const UPDATE_PROFILE_SETUP_FAIL = 'UPDATE_PROFILE_SETUP_FAIL'

export const DELETE_PROFILE_SETUP_REQUEST = 'DELETE_PROFILE_SETUP_REQUEST'
export const DELETE_PROFILE_SETUP_SUCCESS = 'DELETE_PROFILE_SETUP_SUCCESS'
export const DELETE_PROFILE_SETUP_FAIL = 'DELETE_PROFILE_SETUP_FAIL'